// @flow
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Box, Divider, Drawer, Stack, Typography } from '@mui/material';
import { BellIcon, BellRingingIcon } from '@phosphor-icons/react';
import { useReactiveVar } from '@apollo/client';
import { menuCollapsed } from '../../app/ui/menu-toggle-button';
import { RippleBadge } from './ripple-badge';
import { NoData } from '../../shared';
import { RequiredActionOutput } from '@coverright/data-access/types/enrollment';
import { useNotifications } from './required-actions-provider';
import { useLocation } from 'react-router-dom';
import { RequiredActionsList } from './required-actions-list';


export const RequiredActionsDrawerButton = () => {
  const serverActions = useNotifications();
  // this duplication made for smooth animation
  const [requiredActions, setRequiredActions] = useState<RequiredActionOutput[]>([]);
  const location = useLocation();

  const collapsed = useReactiveVar(menuCollapsed);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => setRequiredActions(serverActions), 500)
  }, [serverActions]);

  useEffect(() => {
    if (location.pathname) {
      setOpen(false)
    }
  }, [location.pathname]);

  const handleResolved = (id: string) => {
    setRequiredActions(prev => {
      const val = prev.filter(n => n.id !== id)

      if (!val.length) {
        setOpen(false);
      }

      return val
    });
  };

  return (
    <>
      <Stack sx={{
        mx: 1,
        cursor: 'pointer',
        p: 1, '&:hover': {bgcolor: '#e9f2f5', '& p': {fontWeight: 600} }, borderRadius: '8px',
      }} direction={'row'} alignItems={'center'} onClick={() => setOpen(true)}>
        {!requiredActions.length && <BellIcon size={18} color="#1c434f" style={{ minWidth: 18 }} />}
        {!!requiredActions.length && <>
          {!collapsed && <BellRingingIcon size={18} color="#1c434f" style={{ minWidth: 18 }} />}
          {collapsed && <RippleBadge overlap="rectangular"
                                     invisible={false}
                                     anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                     variant="dot">
            <BellRingingIcon size={18} color="#1c434f" style={{ minWidth: 18 }} />
          </RippleBadge>}
        </>}

        <Typography sx={{ display: 'inline-flex', flex: 1, ml: 1, opacity: collapsed ? 0 : 1, transition: 'opacity .5s ' }}
                    variant={'body2'}
                    color={'#1c434f'}
                    noWrap>Required actions {!!requiredActions.length && `(${requiredActions.length})`}</Typography>

        {!collapsed && !!requiredActions.length && (
          <RippleBadge overlap="rectangular"
                       invisible={false}
                       anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                       variant="dot">
            <Box sx={{width: 1}}/>
          </RippleBadge>
        )}
      </Stack>
      <Drawer open={open}
              anchor={'left'}
              sx={{
                '& .MuiBackdrop-root, & .MuiPaper-root': {
                  left: collapsed ? 50 : 250,
                  boxShadow: 'none',
                }
              }}
              onClose={() => {
                setOpen(false)
              }}>
        <Stack py={2} pl={2} minWidth={400} gap={2}>
          <Typography variant={'subtitle1'}>
            Required actions
          </Typography>
          <Divider sx={{ mb: 1, mr: 2 }} />

          {!requiredActions.length && <NoData>
            No actions needed
          </NoData>}

          <RequiredActionsList actions={requiredActions} onResolved={handleResolved} />
        </Stack>
      </Drawer>
    </>
  )
};
